<svg [attr.width]="width" [attr.height]="width" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle [attr.cx]="width / 2" [attr.cy]="width / 2" [attr.r]="width / 2" [attr.fill]="color" />
</svg>
